<app-modal-frame
  [headerText]="data.edit ? CONSTANTS.EDIT_HEADER : CONSTANTS.ADD_HEADER"
  [leftButton]="getLeftButton"
  [rightButton]="getRightButton"
  (emitLeftClick)="leftButtonClick()"
  (emitRightClick)="rightButtonClick()"
  (emitExit)="onClose()"
>
  <div class="card-content">
    <ion-row class="segment-container">
      <ion-segment
        class="segment ion-justify-content-start"
        [(ngModel)]="currentTab"
      >
        <ion-segment-button
          class="segment-btn"
          [value]="AVAILABLE_TABS.LOCATION"
          [disabled]="
            !data.edit && !this.getIsSectionValid(AVAILABLE_TABS.LOCATION)
          "
        >
          <ion-label>{{ AVAILABLE_TABS.LOCATION }}</ion-label>
        </ion-segment-button>

        <ion-segment-button
          class="segment-btn"
          [value]="AVAILABLE_TABS.GROUP"
          [disabled]="
            !data.edit && !this.getIsSectionValid(AVAILABLE_TABS.GROUP)
          "
        >
          <ion-label>{{ AVAILABLE_TABS.GROUP }}</ion-label>
        </ion-segment-button>

        <ion-segment-button
          class="segment-btn large-btn"
          [value]="AVAILABLE_TABS.CONFIGURATION"
          [disabled]="
            !data.edit && !this.getIsSectionValid(AVAILABLE_TABS.CONFIGURATION)
          "
        >
          <ion-label>{{ AVAILABLE_TABS.CONFIGURATION }}</ion-label>
        </ion-segment-button>
      </ion-segment>
    </ion-row>

    <ion-row class="content">
      @if (currentTab === AVAILABLE_TABS.LOCATION) {
        <app-location-form
          [form]="locationForm"
          [countryList]="countryOptionList"
        ></app-location-form>
      }
      @if (currentTab === AVAILABLE_TABS.GROUP) {
        <app-group [form]="form"></app-group>
      }
      @if (currentTab === AVAILABLE_TABS.CONFIGURATION) {
        <app-configuration
          [form]="configForm"
          [unit]="getCurrUnit"
        ></app-configuration>
      }
    </ion-row>
  </div>
</app-modal-frame>
